/**
 * The sidebar. Each item declares the permission it needs, so a signed-in user
 * only ever sees the sections they can actually open.
 *
 * An item may carry `children`, which renders it as an expandable group. The
 * parent's own `to` is the group's landing page, so clicking the group both
 * expands it and goes somewhere useful rather than doing nothing.
 */
export const NAV_ITEMS = [
  { icon: 'dashboard', label: 'Dashboard', to: '/dashboard', permission: 'dashboard:read' },
  { icon: 'storefront', label: 'Provider', to: '/providers', permission: 'provider:read' },
  { icon: 'category', label: 'Category', to: '/categories', permission: 'category:read' },
  { icon: 'account_tree', label: 'Sub-category', to: '/subcategories', permission: 'subcategory:read' },
  { icon: 'public', label: 'Countries', to: '/countries', permission: 'country:read' },
  { icon: 'admin_panel_settings', label: 'Roles', to: '/roles', permission: 'role:read' },
  { icon: 'receipt_long', label: 'Plans', to: '/plans', permission: 'plan:read' },
  { icon: 'loyalty', label: 'Promo and referral', to: '/referrals', permission: 'referral:read' },
  { icon: 'campaign', label: 'Sponsor', to: '/sponsors', permission: 'sponsor:read' },
  { icon: 'groups', label: 'Team', to: '/team', permission: 'team:read' },
  {
    icon: 'support_agent',
    label: 'Queries',
    to: '/queries/help-desk',
    // Both queues live under /queries, so the section prefix keeps the group lit
    // on either child while the landing page is the first of them.
    match: '/queries',
    permission: 'query:read',
    children: [
      { label: 'Help desk', to: '/queries/help-desk', permission: 'query:read' },
      { label: 'Plan upgrades', to: '/queries/plan-upgrades', permission: 'query:read' },
    ],
  },
  /*
   * Chat sits under Queries rather than beside Team: both are ways a guru reaches the
   * platform, and an operator working one is usually working the other. Its own permission
   * keeps the two separable despite the adjacency.
   */
  { icon: 'chat', label: 'Chat', to: '/chat', permission: 'chat:read' },
  {
    icon: 'payments',
    label: 'Revenue',
    to: '/finance',
    // Payout lives at /finance/payouts, so the section prefix is the landing
    // page itself and the group stays lit on either child.
    match: '/finance',
    permission: 'report:read',
    children: [
      { label: 'Revenue', to: '/finance', permission: 'report:read', end: true },
      { label: 'Payout', to: '/finance/payouts', permission: 'report:read' },
    ],
  },
  {
    icon: 'insights',
    label: 'Insight',
    to: '/insights/providers',
    // The group's landing page is its first child, so the section it owns has
    // to be named separately for the active state to cover both.
    match: '/insights',
    permission: 'insight:read',
    children: [
      { label: 'Provider', to: '/insights/providers', permission: 'insight:read', end: true },
      { label: 'Booking', to: '/insights/bookings', permission: 'insight:read' },
    ],
  },
  { icon: 'history', label: 'Audit log', to: '/audit-log', permission: 'audit:read' },
  { icon: 'settings', label: 'Settings', to: '/settings', permission: 'setting:read' },
];
